import { render, staticRenderFns } from "./PJProposalLimitOfLiability.vue?vue&type=template&id=322c276a"
import script from "./PJProposalLimitOfLiability.vue?vue&type=script&lang=js"
export * from "./PJProposalLimitOfLiability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports